module.exports = __webpack_public_path__ + "static/media/016admin_4 ID scanning @2x.4f6074da.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/016admin_4 ID scanning @2x.png
// module id = 580
// module chunks = 0